import React, { useState } from 'react'
import { Col, Row } from 'antd'


const Basic = (props) => {
    const { onChange } = props
    const [defaultMessage, setDefaultMessage] = useState('There are unsaved changes. Are you sure you want to leave this page?')

    const handleDecision = (decision) => {
        onChange(decision)
    }


    return (
        <div className='w-full p'>
            <div className='p-6 text-center'>
                <p className='mb-2 text-md font-semibold'>{props.message ? props.message : defaultMessage}</p>
            </div>
            <Row >
                { !props?.type ? (
                    <React.Fragment>
                        <Col md={12} sm={12} xs={12}>
                            <div
                                onClick={() => handleDecision(true)}
                                className='cursor-pointer rounded-bl-md btn-primary bg-primary flex justify-center items-center w-full'
                            >
                                <h6 className='heading-6 font-semibold text-black text-sm mb-0'>Yes</h6>
                            </div>
                        </Col>
                        <Col md={12} sm={12} xs={12}>
                            <div
                                onClick={() => handleDecision(false)}
                                className='cursor-pointer rounded-br-md btn-primary bg-black flex justify-center items-center w-full'
                            >
                                <h6 className='heading-6 font-semibold text-sm mb-0'>No</h6>                    </div>
                        </Col>
                    </React.Fragment>
                )  : (
                    <Col span={24}>
                        <div
                            onClick={() => handleDecision(false)}
                            className='cursor-pointer rounded-bl-md rounded-br-md btn-primary bg-primary flex justify-center items-center w-full'
                        >
                            <h6 className='heading-6 font-semibold text-black text-sm mb-0'>OK</h6>
                        </div>
                    </Col>
                ) }
            </Row>
        </div>
    )
}

export default Basic